<template>
  <div>
    <headline-container headline="Edit Payment Condition" :breadcrumbs="breadcrumbs">
      <button type="button" class="btn btn-white pull-right" @click="destroy">
        <i class="fa fa-trash"></i> Delete
      </button>
    </headline-container>

    <loading-container v-if="loading"></loading-container>

    <div v-else class="container">
      <div class="row">
        <div class="col-xs-6">
          <help-text>
            <h3>
              Edit Payment Condition
            </h3>

            <p>
              Enter the details of the payment condition.
            </p>
          </help-text>
        </div>

        <div class="col-xs-18">
          <div class="panel panel-default">
            <div class="panel-body">
              <form @submit.prevent="submit" class="form-horizontal">
                <text-form-group
                    v-model="data.name"
                    name="name"
                    label="Name"
                    help-text="The name of the payment condition."
                    :error="getError('name')"
                ></text-form-group>

                <select-form-group
                    v-model="data.reference"
                    name="reference"
                    label="Reference"
                    help-text="The payment condition in the bookkeeping system that corresponds to this payment condition."
                    :error="getError('reference')"
                    :options="externalPaymentConditionOptions"
                ></select-form-group>

                <number-form-group
                    v-model="data.first_notice_after"
                    name="first_notice_after"
                    label="First Notice After"
                    help-text="An invoice will have its first notice sent this number of days after its start date."
                    :error="getError('first_notice_after')"
                ></number-form-group>

                <number-form-group
                    v-model="data.second_notice_after"
                    name="second_notice_after"
                    label="Second Notice After"
                    help-text="An invoice will have its second notice sent this number of days after its start date."
                    :error="getError('second_notice_after')"
                ></number-form-group>

                <number-form-group
                    v-model="data.third_notice_after"
                    name="third_notice_after"
                    label="Third Notice After"
                    help-text="An invoice will have its third notice sent this number of days after its start date."
                    :error="getError('third_notice_after')"
                ></number-form-group>

                <radio-form-group
                    v-model="data.is_default"
                    name="is_default"
                    label="Is Default"
                    help-text="Select this option of the payment condition should be used as the default."
                    :error="getError('is_default')"
                    :options="[{value: false, label: 'No'}, {value: true, label: 'Yes'}]"
                ></radio-form-group>

                <hr>

                <submit-form-group button-class="btn-black"></submit-form-group>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import modal from '@/modal'
import notify from '@/notify'
import EmailFormGroup from '@/vendor/forms/FormGroups/Horizontal/Email'
import Errors from '@/mixins/Errors'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import HelpText from '@/components/HelpText'
import Load from '@/mixins/Load'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import NumberFormGroup from '@/vendor/forms/FormGroups/Horizontal/Number'
import RadioFormGroup from '@/vendor/forms/FormGroups/Horizontal/Radio'
import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

export default {
  components: {
    HeadlineContainer,
    HelpText,
    LoadingContainer,
    NumberFormGroup,
    RadioFormGroup,
    SelectFormGroup,
    SubmitFormGroup,
    TextFormGroup
  },

  mixins: [Errors],

  props: ['id'],

  data() {
    return {
      data: {},

      externalPaymentConditions: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    breadcrumbs() {
      return [
        {url: '/payment-conditions', text: 'Payment Conditions'},
        {text: 'Edit'}
      ]
    },

    externalPaymentConditionOptions() {
      return this.externalPaymentConditions.map(externalPaymentCondition => {
        return {
          value: externalPaymentCondition.id,
          label: externalPaymentCondition.attributes.name
        }
      })
    }
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/payment-conditions/' + this.id),
        http.get('/api/v2/external-payment-conditions')
      ]).then(responses => {
        this.data = {...responses[0].data.data.attributes}

        this.externalPaymentConditions = responses[1].data.data

        this.loading = false
      })
    },

    submit() {
      http.put('/api/v2/payment-conditions/' + this.id, this.data)
          .then(() => {
            notify.success('The payment condition was saved')

            this.$router.push('/payment-conditions')
          })
          .catch(this.catchValidationErrors)
    },

    destroy() {
      modal.confirm('Are you sure that you want to delete the payment condition?', () => {
        http.delete('/api/v2/payment-conditions/' + this.id)
            .then(() => {
              notify.success('The payment condition was deleted')

              this.$router.push('/payment-conditions')
            })
      })
    }
  }
}
</script>
